import React from 'react';
import project11 from '../../image/project9.png';

const GamersPulse = () => {
    return (
        <div>
           
            <div className=' my-24 '>

                <div class=" container mx-auto grid grid-cols-1  gap-4">
                    <div class="card w-100 bg-base-100 shadow-xl">
                        <figure><img src={project11} alt="Shoes" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                                Ent WareHouse
                                <div class="badge badge-secondary">Full-Stack</div>
                            </h2>
                            <h2>Features</h2>
                            <p> This site features a Electronics Chips inventory management service.
                            User can see inventory and manage their inventory.
                            The site featuring Firebase Authentication. User can sign in and manage inventory.
                            MongoDB Database and Node Express server integrated with Front End UI.
                            CRUD Operation implanted. user can create, retrive , modify, delete Data.</p>
                           <h2>Used Technology</h2>
                            <ol>
                                <li>React Bootstrap</li>
                                <li>React Router Dom</li>
                                <li>Environmente Variable</li>
                                <li>Firebase Authentication</li>
                            </ol>
                           <h2>Other 3rd party Extensions</h2>
                            <ol>
                                <li>React Firebase hooks</li>
                                <li>Fontawesome icons</li>

                            </ol>
                            <div class="card-actions justify-end">
                                <button class="btn btn-primary"><a href="https://ent-warehouse.web.app/" target='_blank'>Live Site</a></button>
                                <button class="btn btn-primary"><a href="https://github.com/sajolbhadra/warehouse-management-client-side" target='_blank'>Client Git Repo</a></button>
                                <button class="btn btn-primary"><a href="https://github.com/sajolbhadra/warehouse-management-server-side" target='_blank'>Server Git</a></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default GamersPulse;